import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { removeSelectedItem, upseartItem } from '@/helpers/CRUD';
import { extractError } from '@/helpers/extractApiError';
import RoleService from '@/services/UsersServices/RoleService';
import { deleteRole } from '../delete/deleteSlice';
import { createRole } from '../create/createSlice';

const model = {
    data: [],
    totalItems: 0,
    loading: false,
    error: null,
};

export const getRoleList = createAsyncThunk(
    'role/getRoleList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await RoleService.getRoleList(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const roleListSlice = createSlice({
    name: 'roleList',
    initialState: model,
    reducers: {},
    extraReducers: (builder) => {
        // role list
        builder.addCase(getRoleList.pending, (state) => {
            state.loading = true;
        }).addCase(getRoleList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getRoleList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle deleting role
        builder.addCase(deleteRole.fulfilled, (state, action) => {
            state.data = removeSelectedItem(state.data, action.payload.roleId);
        });

        // Handle creating and updating role
        builder.addCase(createRole.fulfilled, (state, action) => {
            state.data = upseartItem(state.data, action.payload);
        });
    },
});

export default roleListSlice.reducer;
